import React, { Component } from 'react';
import Select from 'react-select';
import createFilterOptions from 'react-select-fast-filter-options';
import VirtualizedSelect from 'react-virtualized-select';
import classNames from 'classnames';
import 'react-select/dist/react-select.css';

export class Selection extends Component {
  render() {
    const { input, options, defaultValue, defaultPlaceHolder = '', className, meta: { touched, error}  } = this.props;
    const inputClass = classNames({ 'parsley-error-div': touched && error }, className, 'testSelect')
    let isDisabled = false;
    let matchPos = 'start';
    if (this.props.disabled) {
      isDisabled = true;
    }
    if (this.props.matchPos) {
      matchPos = this.props.matchPos;
    }
    if (defaultValue) {
      return (
        <div>
          {touched && error && <span className="parsley-error-message">{error}</span>}
          <Select
            className={inputClass}
            matchPos={matchPos}
            matchProp={'label'}
            options={options}
            {...input}
            value={input.value.value || input.value || defaultValue.value}
            onBlur={() => { input.onBlur(input.value); }}
            disabled={isDisabled}
            onInputKeyDown={this.props.onInputKeyDown}
            ref="select"
            onInputKeyDown={this.props.onKeyPress}
            optionRenderer={this.props.optionRenderer}
          />
        </div>
      )
    }
    if(defaultPlaceHolder) {
      return (
        <div>
        {touched && error && <span className="parsley-error-message">{error}</span>}
          <Select
            className={inputClass}
            matchPos={matchPos}
            matchProp={'label'}
            options={options}
            {...input}
            value={input.value.value || input.value}
            onBlur={() => { input.onBlur(input.value); }}
            disabled={isDisabled}
            onInputKeyDown={this.props.onInputKeyDown}
            ref="select"
            placeholder={defaultPlaceHolder}
            onInputKeyDown={this.props.onKeyPress}
            optionRenderer={this.props.optionRenderer}
          />
        </div>
      );
    }
    return (
      <div>
      {touched && error && <span className="parsley-error-message">{error}</span>}
        <Select
          className={inputClass}
          matchPos={matchPos}
          matchProp={'label'}
          options={options}
          {...input}
          value={input.value.value || input.value}
          onBlur={() => { input.onBlur(input.value); }}
          disabled={isDisabled}
          onInputKeyDown={this.props.onInputKeyDown}
          ref="select"
          onInputKeyDown={this.props.onKeyPress}
          optionRenderer={this.props.optionRenderer}
        />
      </div>
    );
  }
}

export class SelectionWithProps extends Component {
  render() {
    const { input, options, className, onChange, meta: { touched, error }, multi } = this.props;
    const inputClass = classNames({ 'parsley-error-div': touched && error }, className, "testSelect");
    return (
      <div>
        {touched && error && <span className="parsley-error-message">{error}</span>}
        <Select
          className={inputClass}
          matchPos={"start"}
          matchProp={'label'}
          options={options}
          {...input}
          {...this.props}
          ref="select"
          value={input.value.value || input.value}
          onBlur={() => { input.onBlur(input.value); }}
          onChange={(event) => {
            input.onChange(event);
            if (typeof onChange === 'function') {
              onChange(event);
            }
            this.props.onSelect && this.props.onSelect(event)
          }}
          multi={multi || false}
          optionRenderer={this.props.optionRenderer}
        />
      </div>
    );
  }
}

export class SelectionWide extends Component {
  render() {
    const { input, options, className, meta: { touched, error}  } = this.props;
    const inputClass = classNames({ 'parsley-error-div': touched && error }, className, "testSelect")
    return (
      <div>
        {touched && error && <span className="parsley-error-message">{error}</span>}
        <Select
          className={inputClass}
          matchProp={'label'}
          options={options}
          {...input}
          value={input.value.value || input.value}
          onBlur={() => { input.onBlur(input.value); }}
          optionRenderer={this.props.optionRenderer}
        />
      </div>
    )
  }
}

export class DisabledSelection extends Component {
  render() {
    const { input, options, defaultValue, className, meta: { touched, error}  } = this.props;
    const inputClass = classNames({ 'parsley-error-div': touched && error }, className, "testSelect")
    return (
      <div>
        {touched && error && <span className="parsley-error-message">{error}</span>}
        <Select
          className={inputClass}
          value={defaultValue}
          options={options}
          {...input}
          onBlur={() => { input.onBlur(input.value); }}
          disabled={true}
          ref="select"
          optionRenderer={this.props.optionRenderer}
        />
      </div>
    );
  }
}

export class MultiSelection extends Component {
  render() {
    const { input, options, defaultValue, className, meta: { touched, error} } = this.props;
    const inputClass = classNames({ 'parsley-error-div': touched && error }, className, "testSelect")
    let isDisabled = false;
    if (this.props.disabled) {
      isDisabled = true;
    }
    return (
      <div>
        {touched && error && <span className="parsley-error-message">{error}</span>}
        <Select
          className={inputClass}
          multi
          options={options}
          {...input}
          value={input.value.value || input.value}
          onBlur={() => { input.onBlur(input.value); }}
          disabled={isDisabled}
          optionRenderer={this.props.optionRenderer}
        />
      </div>
    );
  }
}

export class VirtualizedSelection extends Component {
  render() {
    const { input, options, defaultValue, className, meta: { touched, error} } = this.props;
    const inputClass = classNames({ 'parsley-error-div': touched && error }, className, "testSelect")
    const filterOptions = createFilterOptions({ options })

    let isDisabled = false;
    if (this.props.disabled) {
      isDisabled = true;
    }
    if (defaultValue) {
      return (
        <div>
          {touched && error && <span className="parsley-error-message">{error}</span>}
          <VirtualizedSelect
            className={inputClass}
            filterOptions={filterOptions}
            options={options}
            {...input}
            value={input.value.value || input.value || defaultValue.value}
            onBlur={() => { input.onBlur(input.value); }}
            disabled={isDisabled}
            onInputKeyDown={this.props.onInputKeyDown}
          />
        </div>
      );
    }
    return (
      <div>
        {touched && error && <span className="parsley-error-message">{error}</span>}
        <VirtualizedSelect
          className={inputClass}
          filterOptions={filterOptions}
          options={options}
          {...input}
          value={input.value.value || input.value}
          onBlur={() => { input.onBlur(input.value); }}
          disabled={isDisabled}
          onInputKeyDown={this.props.onInputKeyDown}
        />
      </div>
    );
  }
}

export default Selection;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/selection.jsx